"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {String} mask
 * @param format
 * @returns {Array}
 */
function defineMaskList(mask, format) {
    if (!mask) {
        return [];
    }
    var stack = [];
    // flag if escape char is used
    var escape = false;
    mask.split('').forEach(function (maskChar) {
        var item = format[maskChar];
        // if the previous char was escape char, we should ignore next format rule, and process mask char as a regular char.
        if (escape && item) {
            item = null;
            escape = false;
        }
        if (!item) {
            // escape char
            if (!escape && maskChar === '\\') {
                escape = true;
                return;
            }
            escape = false;
            stack.push({
                char: maskChar,
            });
            return;
        }
        if (item.regexp) {
            stack.push(item);
        }
    });
    return stack;
}
exports.default = defineMaskList;
